import type { TFunction } from "i18next";
import type { CensusReplacement } from "./models";

/** "PCC replaced your 55 with 53" */
export function formatCensusReplacementNotice(t: TFunction, source: string, notice: CensusReplacement): string {
	return t("census.replacement.notice", {
		source,
		previous: Math.round(notice.previous_value),
		replacement: Math.round(notice.replacement_value),
	});
}

/** The census tooltip line that explains the amber marker; none when the day has no open notice. */
export function censusReplacementSummaryLines(t: TFunction, source: string, notice: CensusReplacement | undefined): Array<{ label: string }> {
	return notice ? [{ label: formatCensusReplacementNotice(t, source, notice) }] : [];
}
